import backIcon from 'presentation/assets/icons/png/3x/icn-arrow-left-big@3x.png';
import Icon, { ICONSIZE } from 'presentation/components/Icon';
import React from 'react';

interface PrevButtonProps {
  handleClick: () => void;
}

const PrevButton: React.FC<PrevButtonProps> = ({ handleClick }) => (
  <div className="prev-button">
    <Icon
      iconSrc={backIcon}
      handleClick={handleClick}
      size={ICONSIZE.medium}
      alt="back icon"
      additionalTestId="prev"
    />
  </div>
);

export { PrevButton };
